import {
  HttpContextToken,
  HttpErrorResponse,
  HttpHandlerFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { UIService } from '@core/services/ui.service';
import { getErrorMessage } from '@core/utils/http-errors';
import { TranslateService } from '@ngx-translate/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

export function HttpInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) {
  const uiService = inject(UIService);
  const translateService = inject(TranslateService);

  if (req.context.get(SKIP_ERROR_TOAST)) {
    return next(req);
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        return throwError(() => error);
      }

      const errorMessage = getErrorMessage(error);

      uiService.showToast({
        severity: 'error',
        summary: translateService.instant(errorMessage),
        life: 3000,
        closable: false,
      });

      return throwError(() => error);
    })
  );
}
